import axios from "axios";
import * as actionType from "../../../constant/actionType";

const GenerateClientCompChecklistReportFunction = (apiData) => async (dispatch) => {
 try {
  console.log("Working ??")
  const response = await axios({
   method: "post",
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/GenerateClientCompChecklistReportFunction`,
   data: {
    ...apiData,
    client_org_ids: JSON.stringify(apiData?.client_org_ids),
   },
  });

  return response.data;
 } catch (error) {
  console.error("GenerateClientCompChecklistReportFunction failed", error);
  throw error.response?.data || error;
 }
};

export { GenerateClientCompChecklistReportFunction };

